import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utility/axiosInstance";

export interface RedisInstance {
    id: number;
    name: string;
    version: string;
    status: "provisioning" | "ready" | "error";
    floating_ip: string | null;
    port: number;
    instance_id: string;
    created_at: string;
    access_point?: string | null;
    private_ip?: string | null;
    password?: string;
}

interface RedisState {
    instances: RedisInstance[];
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
}

const initialState: RedisState = { instances: [], status: "idle", error: null };

export const fetchRedis = createAsyncThunk("redis/fetch", async () => {
    const res = await axiosInstance.get("/v1/redis");
    return res.data as RedisInstance[];
});

export const deleteRedis = createAsyncThunk("redis/delete", async (id: number) => {
    await axiosInstance.delete(`/v1/redis/${id}`);
    return id;
});

const redisSlice = createSlice({
    name: "redis",
    initialState,
    reducers: {
        addRedis: (state, action) => { state.instances.unshift(action.payload); },
        updateRedisStatus: (state, action) => {
            const inst = state.instances.find(i => i.id === action.payload.id);
            if (inst) { inst.status = action.payload.status; inst.floating_ip = action.payload.floating_ip ?? inst.floating_ip; }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRedis.pending,   (s) => { s.status = "loading"; })
            .addCase(fetchRedis.fulfilled, (s, a) => { s.status = "succeeded"; s.instances = a.payload; })
            .addCase(fetchRedis.rejected,  (s, a) => { s.status = "failed"; s.error = a.error.message ?? null; })
            .addCase(deleteRedis.fulfilled,(s, a) => { s.instances = s.instances.filter(i => i.id !== a.payload); });
    },
});

export const { addRedis, updateRedisStatus } = redisSlice.actions;
export default redisSlice.reducer;
